/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as CallbackMethodImport } from './routes/callback.$method'
import { Route as AuthUsersImport } from './routes/_auth.users'
import { Route as AuthDashboardImport } from './routes/_auth.dashboard'
import { Route as AuthCompaniesIndexImport } from './routes/_auth.companies.index'
import { Route as AuthCompaniesIdTabImport } from './routes/_auth.companies.$id.$tab'
import { Route as AuthCompagniesIdProductsProductIdImport } from './routes/_auth.compagnies.$id.products.$productId'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const CallbackMethodRoute = CallbackMethodImport.update({
  id: '/callback/$method',
  path: '/callback/$method',
  getParentRoute: () => rootRoute,
} as any)

const AuthUsersRoute = AuthUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDashboardRoute = AuthDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCompaniesIndexRoute = AuthCompaniesIndexImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCompaniesIdTabRoute = AuthCompaniesIdTabImport.update({
  id: '/companies/$id/$tab',
  path: '/companies/$id/$tab',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCompagniesIdProductsProductIdRoute =
  AuthCompagniesIdProductsProductIdImport.update({
    id: '/compagnies/$id/products/$productId',
    path: '/compagnies/$id/products/$productId',
    getParentRoute: () => AuthRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardImport
      parentRoute: typeof AuthImport
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersImport
      parentRoute: typeof AuthImport
    }
    '/callback/$method': {
      id: '/callback/$method'
      path: '/callback/$method'
      fullPath: '/callback/$method'
      preLoaderRoute: typeof CallbackMethodImport
      parentRoute: typeof rootRoute
    }
    '/_auth/companies/': {
      id: '/_auth/companies/'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthCompaniesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/companies/$id/$tab': {
      id: '/_auth/companies/$id/$tab'
      path: '/companies/$id/$tab'
      fullPath: '/companies/$id/$tab'
      preLoaderRoute: typeof AuthCompaniesIdTabImport
      parentRoute: typeof AuthImport
    }
    '/_auth/compagnies/$id/products/$productId': {
      id: '/_auth/compagnies/$id/products/$productId'
      path: '/compagnies/$id/products/$productId'
      fullPath: '/compagnies/$id/products/$productId'
      preLoaderRoute: typeof AuthCompagniesIdProductsProductIdImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthUsersRoute: typeof AuthUsersRoute
  AuthCompaniesIndexRoute: typeof AuthCompaniesIndexRoute
  AuthCompaniesIdTabRoute: typeof AuthCompaniesIdTabRoute
  AuthCompagniesIdProductsProductIdRoute: typeof AuthCompagniesIdProductsProductIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRoute,
  AuthUsersRoute: AuthUsersRoute,
  AuthCompaniesIndexRoute: AuthCompaniesIndexRoute,
  AuthCompaniesIdTabRoute: AuthCompaniesIdTabRoute,
  AuthCompagniesIdProductsProductIdRoute:
    AuthCompagniesIdProductsProductIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthDashboardRoute
  '/users': typeof AuthUsersRoute
  '/callback/$method': typeof CallbackMethodRoute
  '/companies': typeof AuthCompaniesIndexRoute
  '/companies/$id/$tab': typeof AuthCompaniesIdTabRoute
  '/compagnies/$id/products/$productId': typeof AuthCompagniesIdProductsProductIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthDashboardRoute
  '/users': typeof AuthUsersRoute
  '/callback/$method': typeof CallbackMethodRoute
  '/companies': typeof AuthCompaniesIndexRoute
  '/companies/$id/$tab': typeof AuthCompaniesIdTabRoute
  '/compagnies/$id/products/$productId': typeof AuthCompagniesIdProductsProductIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/users': typeof AuthUsersRoute
  '/callback/$method': typeof CallbackMethodRoute
  '/_auth/companies/': typeof AuthCompaniesIndexRoute
  '/_auth/companies/$id/$tab': typeof AuthCompaniesIdTabRoute
  '/_auth/compagnies/$id/products/$productId': typeof AuthCompagniesIdProductsProductIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/dashboard'
    | '/users'
    | '/callback/$method'
    | '/companies'
    | '/companies/$id/$tab'
    | '/compagnies/$id/products/$productId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/dashboard'
    | '/users'
    | '/callback/$method'
    | '/companies'
    | '/companies/$id/$tab'
    | '/compagnies/$id/products/$productId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/dashboard'
    | '/_auth/users'
    | '/callback/$method'
    | '/_auth/companies/'
    | '/_auth/companies/$id/$tab'
    | '/_auth/compagnies/$id/products/$productId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  CallbackMethodRoute: typeof CallbackMethodRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  CallbackMethodRoute: CallbackMethodRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/login",
        "/callback/$method"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/dashboard",
        "/_auth/users",
        "/_auth/companies/",
        "/_auth/companies/$id/$tab",
        "/_auth/compagnies/$id/products/$productId"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_auth/dashboard": {
      "filePath": "_auth.dashboard.tsx",
      "parent": "/_auth"
    },
    "/_auth/users": {
      "filePath": "_auth.users.tsx",
      "parent": "/_auth"
    },
    "/callback/$method": {
      "filePath": "callback.$method.tsx"
    },
    "/_auth/companies/": {
      "filePath": "_auth.companies.index.tsx",
      "parent": "/_auth"
    },
    "/_auth/companies/$id/$tab": {
      "filePath": "_auth.companies.$id.$tab.tsx",
      "parent": "/_auth"
    },
    "/_auth/compagnies/$id/products/$productId": {
      "filePath": "_auth.compagnies.$id.products.$productId.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
